import { useTranslation } from 'next-i18next';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { HeaderContext } from '@contexts/HeaderContext';
import React, { useContext, useEffect, useState } from 'react';
import SiteMapping from '@configs/siteMapping';
import { platformList } from '../../utils/dropdownList';

const DrownDownIconLayout = ({
    layoutType, dropdownType, selectIconName, languageState, platformState,
}) => {
    const { t } = useTranslation();
    return (
        <>
            {layoutType === 'header'
                ? (
                    <>
                        <div className="dropdown__btn">
                            <i className="icon icon--gradient-third">
                                <i className={selectIconName} />
                            </i>
                        </div>
                        <span className="text">
                            {{
                                platform: t(platformState),
                                language: t(languageState),
                            }[dropdownType]}
                        </span>
                    </>
                )
                : ( // footer
                    <a className="dropdown__btn">
                        <i className={`${selectIconName}`} />
                        <span className="text">
                            {{
                                platform: t(platformState),
                                language: t(languageState),
                            }[dropdownType]}
                        </span>
                        <i className="icon icon--arrow-down" />
                    </a>
                )}
        </>
    );
};

export const getNameByCode = (array, code) => {
    // TODO: 改變數名稱，要有 i18 的字樣
    return array.find((item) => item.code === code)?.name;
};

export const Icon = ({
    siteName, dropdownType, selectIconName,
    layoutType,
}) => {
    const { t } = useTranslation();
    const [headerState] = useContext(HeaderContext);
    const { languageList } = useSiteInfo();
    const [isDomLoaded, setIsDomLoaded] = useState(false);

    const [platformState, setPlatformState] = useState();
    const [languageState, setLanguageState] = useState(headerState.language);

    useEffect(() => {
        setIsDomLoaded(true);
    }, []);

    useEffect(() => {
        setPlatformState(getNameByCode(platformList, headerState.platform));
        setLanguageState(getNameByCode(languageList, headerState.language));
    }, [headerState, languageList]);

    if (!isDomLoaded) return [];

    return (
        {
            [siteName]: <DrownDownIconLayout
                layoutType={layoutType}
                dropdownType={dropdownType}
                selectIconName={selectIconName}
                languageState={languageState}
                platformState={platformState}
            />,
            [SiteMapping.viva88]: (
                <>
                    <a className="btn btn--icon">
                        <i className={selectIconName} />
                    </a>
                    <span className="text">
                        {{
                            platform: t(platformState),
                            language: t(languageState),
                        }[dropdownType]}
                    </span>
                </>
            ),
            [SiteMapping.bong88]: (
                <>
                    <a className="btn btn--icon">
                        <i className={selectIconName} />
                    </a>
                    <span className="text">
                        {{
                            platform: t(platformState),
                            language: t(languageState),
                        }[dropdownType]}
                    </span>
                </>
            ),
        }[siteName]
    );
};
